/**
 * @description api请求基础路径
 */
 let baseUrl = ''
 /**
 * @description 课程api
 */
  let courseUrl = ''
   /**
 * @description 课程api
 */
  let userUrl = ''
     /**
 * @description 数据采集API
 */
  let dataUrl = ''
 
 // 区分环境
 let env =
   process.env.NODE_ENV === 'development'
     ? 'development'
     : process.env.VUE_APP_TITLE === 'test'
       ? 'test'
       : process.env.VUE_APP_TITLE === 'develop'
         ? 'develop'
         : 'production'
 
 switch (env) {
   case 'development':
    baseUrl = 'https://coursetest.linglan.com' // 这里是线上开发环境中的url
    courseUrl = 'https://coursetest.linglan.com'
    userUrl = 'https://usertest.linglan.com'
    dataUrl = 'https://datatest.linglan.com'
     break
   case 'develop':
     baseUrl = 'https://coursetest.linglan.com' // 这里是线上开发环境中的url
     courseUrl = 'https://coursetest.linglan.com'
     userUrl = 'https://usertest.linglan.com'
     dataUrl = 'https://datatest.linglan.com'
     break
   case 'test':
     baseUrl = 'https://coursetest.linglan.com' // 线上测试环境url
     courseUrl = 'https://coursetest.linglan.com'
     userUrl = 'https://usertest.linglan.com'
     dataUrl = 'https://datatest.linglan.com'
     break
   case 'production':
     baseUrl = 'https://course.linglan.com' // 线上生产环境url
     courseUrl = 'https://course.linglan.com'
     userUrl = 'https://user.linglan.com'
     dataUrl = 'https://data.linglan.com'
     break
 }
 
 // export default baseUrl
 export { baseUrl,courseUrl,userUrl,dataUrl }
 